import React from "react";

export default function ForgotPasswordModal(props) {
  return (
    <div>
      <div
        style={{
          boxShadow:
            "0px 1px 2px -1px rgba(0, 0, 0, 0.10), 0px 1px 3px 0px rgba(0, 0, 0, 0.10)",
        }}
        className="w-[28rem] pt-6 pb-6 rounded-[8px]"
      >
        <div className="flex items-center justify-center">
          <div className="w-[90%]">
            <img className="w-[3.2rem]" src={props.img} />
            <div className="flex flex-col gap-2 mt-3">
              <p className="text-[1.1rem] font-[700] text-[#111928]">
                {props.heading}
              </p>
              <p className="text-[1rem] text-[#6B7280]">
                {props.text}{" "}
                <span className="text-[#942A27]">{props.spantext}</span>
              </p>
            </div>
            <div className="flex items-start flex-col gap-1 mt-4">
              <label className="text-[0.95rem] text-[#111928] font-[500]">
                Email
              </label>
              <input
                className="w-full h-[2.6rem] border-[1px] border-[#D1D5DB] bg-[#F9FAFB] text-[0.90rem] text-[#6B7280] pl-3 outline-none rounded-[8px]"
                type="text"
                placeholder="name@example.com"
              />
            </div>
            <div className="mt-5">
              {props.btntext && (
                <button className="w-full h-[2.5rem] bg-[#942A27] rounded-[8px] text-[0.95rem] text-white font-[500]">
                  {props.btntext}
                </button>
              )}
            </div>
            <p className="text-[0.94rem] font-[500] text-[#111928] mt-4">Back to <span className="text-[#942A27] cursor-pointer">Login</span></p>
          </div>
        </div>
      </div>
    </div>
  );
}
